import { FileText, Phone } from "lucide-react";
import { PHONE_HREF } from "./content";

export const MobileBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-[var(--line)] bg-white/95 p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] backdrop-blur-md md:hidden"
    data-testid="mobile-cta-bar"
  >
    <a href={PHONE_HREF} className="btn btn-outline !px-3" data-testid="mobile-call-button">
      <Phone size={18} aria-hidden /> Ring
    </a>
    <a href="#offert" className="btn btn-red !px-3" data-testid="mobile-quote-button">
      <FileText size={18} aria-hidden /> Begär offert
    </a>
  </div>
);
